document.addEventListener("DOMContentLoaded", () => {
    const container = document.querySelector("#wishlist-container");
    if (!container) return;

    const getList = () => {
        try { return JSON.parse(localStorage.getItem("wishlist")) || []; }
        catch { return []; }
    };

    async function renderWishlist() {
        const list = getList();
        if (!list.length) {
            const msg = document.querySelector("#wishlist-container").dataset.emptyMessage;
            container.innerHTML = "<p>" + msg + "</p>";
            return;
        }

        container.innerHTML = "";

        for (const item of list) {
            const res = await fetch(`/products/${item.handle}?variant=${item.variantId}&section_id=wishlist-product-card`);
            const html = await res.text();

            container.insertAdjacentHTML("beforeend", html);
        }

        container.addEventListener("click", (e) => {
            if (e.target.matches(".wishlist-remove-btn")) {
                const handle = e.target.dataset.handle;
                const variantId = e.target.dataset.variantId;

                let list = JSON.parse(localStorage.getItem("wishlist") || "[]");
                list = list.filter(i => i.variantId !== variantId);
                localStorage.setItem("wishlist", JSON.stringify(list));

                e.target.closest(".shopify-section").remove();
            }
        });
    }

    renderWishlist();
});
